"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withIconComponent;

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("@dcl/shared-components/dist/components/Svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var largeIconViewBox = "0 0 64 64";
var smallIvonViewBox = "0 0 24 24";

var Icon = function Icon(props) {
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react["default"].createElement(_Svg["default"], props, props.children)
  );
};

var SvgContainer = function SvgContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children);
};

function withIconComponent(displayName) {
  var isLarge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var viewBox = isLarge ? largeIconViewBox : smallIvonViewBox;

  var iconBuilder = function iconBuilder(SvgIcon) {
    var IconContainer = function IconContainer(props) {
      return /*#__PURE__*/_react["default"].createElement(Icon, props, /*#__PURE__*/_react["default"].createElement(SvgContainer, {
        viewBox: viewBox
      }, /*#__PURE__*/_react["default"].createElement(SvgIcon, null)));
    };

    IconContainer.displayName = displayName;
    IconContainer.svg = /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox
    }, /*#__PURE__*/_react["default"].createElement(SvgIcon, null));
    return IconContainer;
  };

  return iconBuilder;
}